import { useOctokit } from './useOctokit'
import { useFirebaseAuth } from './useFirebaseAuth'


export const useLogout = () => {
  const [octokit, setAuth] = useOctokit()
  const firebaseAuth = useFirebaseAuth()

  function inner() {
    firebaseAuth.signOut().then(() => {
      setAuth({ accessToken: undefined, username: undefined, permission: undefined })
    })
  }
  return inner
}
